import { render, staticRenderFns } from "./ClickAndBuyColorForm.vue?vue&type=template&id=7f294280&scoped=true"
import script from "./ClickAndBuyColorForm.vue?vue&type=script&lang=js"
export * from "./ClickAndBuyColorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f294280",
  null
  
)

export default component.exports